/**
 * Created by Mark on 17/04/2017.
 */

import React  from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardHead from '../components/card-header.js';
import CardBody from '../components/card-body.js';
import ClassScores from "../components/class-archive-widget.js";
import {Breadcrumb} from 'react-bootstrap';

const Units = [];
export default class ScoresComponent extends React.Component {

    constructor(props) {
        super();
    }

    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-785' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }



    render(){
        return  <Layout>
                     {this.getBreadCrumb()}
                    <Card>
                        <CardHead>
                            <h2><FormattedMessage id={ 'ui-785' } defaultMessage={ 'Scores & reports' }/></h2>
                        </CardHead>
                        <CardBody>
<ClassScores/>
                        </CardBody>
                    </Card>
                </Layout>
    }

}




// WEBPACK FOOTER //
// ./src/screens/classes-archive-reports.js